module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "007c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9aad");
/* harmony import */ var _NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2658");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6b0d");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_2__);





const __exports__ = /*#__PURE__*/_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_2___default()(_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__["default"], [['render',_NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0__["render"]]])

/* harmony default export */ __webpack_exports__["default"] = (__exports__);

/***/ }),

/***/ "05e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

var _vue = __webpack_require__("8bbf");

var _hoisted_1 = ["aria-label"];
var _hoisted_2 = ["aria-label"];
var _hoisted_3 = ["id", "value", "checked"];
var _hoisted_4 = ["for"];
var _hoisted_5 = {
  key: 0,
  class: "folder__create"
};
var _hoisted_6 = {
  class: "folder__form"
};
var _hoisted_7 = ["placeholder", "aria-label"];
var _hoisted_8 = ["aria-label", "disabled"];
var _hoisted_9 = ["aria-label"];
var _hoisted_10 = {
  key: 0,
  class: "folder__browse browse-items",
  role: "list"
};
var _hoisted_11 = {
  key: 2,
  ref: "loadMoreBanner",
  class: "folder folder--loading-indicator",
  role: "listitem"
};
var _hoisted_12 = {
  class: "folder__selectable"
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_LoadingSpinner = (0, _vue.resolveComponent)("LoadingSpinner");

  var _component_NebulaIcon = (0, _vue.resolveComponent)("NebulaIcon");

  var _component_FolderParent = (0, _vue.resolveComponent)("FolderParent", true);

  return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", null, [(0, _vue.createElementVNode)("div", {
    class: (0, _vue.normalizeClass)(["folder", {
      'folder-parent': $options.mycontent.root,
      'opened': $data.folderOpened
    }]),
    role: "listitem"
  }, [(0, _vue.createElementVNode)("div", {
    class: (0, _vue.normalizeClass)(["folder__selectable", {
      'folder__selectable--selected': $options.selected
    }])
  }, [$options.isFolder ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)(_vue.Fragment, {
    key: 0
  }, [(0, _vue.createElementVNode)("button", {
    class: "folder__icon-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.handleFolderToggleClick && $options.handleFolderToggleClick.apply($options, arguments);
    }),
    "aria-label": $options.toggleFolderButtonLabel
  }, [$data.folderIsLoading ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_LoadingSpinner, {
    key: 0,
    isLoading: ""
  })) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_NebulaIcon, {
    key: 1,
    class: "comet-button__icon comet-button__icon--left",
    symbolId: "caret-up",
    size: "s",
    classOverride: $options.caretStatus
  }, null, 8, ["classOverride"]))], 8, _hoisted_1), (0, _vue.createElementVNode)("button", {
    class: "folder__item",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.handleFolderTitleClick && $options.handleFolderTitleClick.apply($options, arguments);
    }),
    "aria-label": $options.titleFolderButtonLabel
  }, [(0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($options.mycontent.root ? _ctx.$t($options.mycontent.title) : $options.mycontent.title), 1)], 8, _hoisted_2)], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)(_vue.Fragment, {
    key: 1
  }, [(0, _vue.createElementVNode)("input", {
    type: "checkbox",
    class: "folder__checkbox",
    id: "my-content-modal-asset--".concat($options.mycontent.id),
    value: $options.mycontent.id,
    checked: $options.selected,
    onChange: _cache[2] || (_cache[2] = function () {
      return $options.toggleAsset && $options.toggleAsset.apply($options, arguments);
    })
  }, null, 40, _hoisted_3), (0, _vue.createElementVNode)("label", {
    for: "my-content-modal-asset--".concat($options.mycontent.id),
    class: "folder__item folder__item--asset"
  }, [(0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($options.mycontent.title), 1)], 8, _hoisted_4)], 64))], 2), $options.showAddNewFolderActive ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [(0, _vue.createElementVNode)("div", _hoisted_6, [(0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
    class: "folder__input comet-form__input",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.folderTitle = $event;
    }),
    placeholder: _ctx.$t('Folder Name'),
    type: "text",
    "aria-label": _ctx.$t('Enter folder name'),
    ref: "addNewFolderInput"
  }, null, 8, _hoisted_7), [[_vue.vModelText, $data.folderTitle]]), (0, _vue.createElementVNode)("button", {
    class: (0, _vue.normalizeClass)(["comet-button comet-button--primary", $options.isDisabled && 'comet-button--disabled']),
    "aria-label": _ctx.$t('Add folder'),
    onClick: _cache[4] || (_cache[4] = (0, _vue.withModifiers)(function () {
      return $options.createNewFolder && $options.createNewFolder.apply($options, arguments);
    }, ["prevent"])),
    disabled: $options.isDisabled
  }, [(0, _vue.createVNode)(_component_NebulaIcon, {
    class: "comet-button__icon comet-button__icon--left",
    symbolId: "check",
    size: "s"
  })], 10, _hoisted_8), (0, _vue.createElementVNode)("button", {
    class: "comet-button comet-button--danger",
    onClick: _cache[5] || (_cache[5] = (0, _vue.withModifiers)(function () {
      return $options.removeAddNewFolderForm && $options.removeAddNewFolderForm.apply($options, arguments);
    }, ["prevent"])),
    "aria-label": _ctx.$t('Cancel adding folder')
  }, [(0, _vue.createVNode)(_component_NebulaIcon, {
    class: "comet-button__icon comet-button__icon--left",
    symbolId: "x",
    size: "s"
  })], 8, _hoisted_9)])])) : (0, _vue.createCommentVNode)("", true)], 2), $options.filteredContent && $options.filteredContent.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [$props.isImagesOnly ? ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, {
    key: 0
  }, (0, _vue.renderList)($options.filteredImages, function (child) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_FolderParent, {
      key: child.id,
      isChooseModal: $props.isChooseModal,
      isFromMyContent: $props.isFromMyContent,
      options: {
        myContent: child
      },
      selectedTab: $props.selectedTab,
      isImagesOnly: $props.isImagesOnly
    }, null, 8, ["isChooseModal", "isFromMyContent", "options", "selectedTab", "isImagesOnly"]);
  }), 128)) : ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, {
    key: 1
  }, (0, _vue.renderList)($options.filteredContent, function (child) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_FolderParent, {
      key: child.id,
      isChooseModal: $props.isChooseModal,
      isFromMyContent: $props.isFromMyContent,
      options: {
        myContent: child
      },
      selectedTab: $props.selectedTab,
      isImagesOnly: $props.isImagesOnly
    }, null, 8, ["isChooseModal", "isFromMyContent", "options", "selectedTab", "isImagesOnly"]);
  }), 128)), $options.nextPage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [(0, _vue.createElementVNode)("div", _hoisted_12, [(0, _vue.createVNode)(_component_LoadingSpinner, {
    isLoading: ""
  }), (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)(_ctx.$t('Loading more...')), 1)])], 512)) : (0, _vue.createCommentVNode)("", true)])) : (0, _vue.createCommentVNode)("", true)]);
}

/***/ }),

/***/ "0676":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var buildURL = __webpack_require__("30b5");
var InterceptorManager = __webpack_require__("f6b4");
var dispatchRequest = __webpack_require__("5270");
var mergeConfig = __webpack_require__("4a7b");
var validator = __webpack_require__("848b");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "102f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}html{color:#595959;font-family:Proxima Vara,Arial,sans-serif;font-weight:400;line-height:1.4;font-size:1.125rem;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:16px}.nebula-screenreader-only{clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}.my-content-modal__spinner .fade-enter-active,.my-content-modal__spinner .fade-leave-active{-webkit-transition:opacity .25s ease-in-out;transition:opacity .25s ease-in-out}.my-content-modal__spinner .fade-enter,.my-content-modal__spinner .fade-leave-to{opacity:0}.my-content-modal__spinner svg{height:80px;width:80px}.my-content__browse .folder__icon-btn .my-content-modal__spinner{min-height:0}.my-content__browse .folder__icon-btn .my-content-modal__spinner svg{height:18px;width:18px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "11b0":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "164b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

var _vue = __webpack_require__("8bbf");

var _hoisted_1 = {
  key: 0,
  class: "my-content-modal__spinner"
};
var _hoisted_2 = {
  class: "comet-spinner comet-spinner--on-light"
};
var _hoisted_3 = {
  class: "comet-spinner__icon",
  "aria-labelledby": "title",
  viewBox: "-10 -10 220 220"
};

var _hoisted_4 = /*#__PURE__*/(0, _vue.createElementVNode)("defs", null, [/*#__PURE__*/(0, _vue.createElementVNode)("linearGradient", {
  id: "spinner-color-1",
  gradientUnits: "objectBoundingBox",
  x1: "0",
  y1: "0",
  x2: "1",
  y2: "1"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "0%",
  "stop-color": "#7B869D",
  "stop-opacity": "0"
}), /*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "100%",
  "stop-color": "#7B869D",
  "stop-opacity": ".2"
})]), /*#__PURE__*/(0, _vue.createElementVNode)("linearGradient", {
  id: "spinner-color-2",
  gradientUnits: "objectBoundingBox",
  x1: "0",
  y1: "0",
  x2: "0",
  y2: "1"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "0%",
  "stop-color": "#7B869D",
  "stop-opacity": ".2"
}), /*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "100%",
  "stop-color": "#7B869D",
  "stop-opacity": ".4"
})]), /*#__PURE__*/(0, _vue.createElementVNode)("linearGradient", {
  id: "spinner-color-3",
  gradientUnits: "objectBoundingBox",
  x1: "1",
  y1: "0",
  x2: "0",
  y2: "1"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "0%",
  "stop-color": "#7B869D",
  "stop-opacity": ".4"
}), /*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "100%",
  "stop-color": "#7B869D",
  "stop-opacity": ".6"
})]), /*#__PURE__*/(0, _vue.createElementVNode)("linearGradient", {
  id: "spinner-color-4",
  gradientUnits: "objectBoundingBox",
  x1: "1",
  y1: "1",
  x2: "0",
  y2: "0"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "0%",
  "stop-color": "#7B869D",
  "stop-opacity": ".6"
}), /*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "100%",
  "stop-color": "#7B869D",
  "stop-opacity": ".8"
})]), /*#__PURE__*/(0, _vue.createElementVNode)("linearGradient", {
  id: "spinner-color-5",
  gradientUnits: "objectBoundingBox",
  x1: "0",
  y1: "1",
  x2: "0",
  y2: "0"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "0%",
  "stop-color": "#7B869D",
  "stop-opacity": ".8"
}), /*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "100%",
  "stop-color": "#7B869D",
  "stop-opacity": "1"
})]), /*#__PURE__*/(0, _vue.createElementVNode)("linearGradient", {
  id: "spinner-color-6",
  gradientUnits: "objectBoundingBox",
  x1: "0",
  y1: "1",
  x2: "1",
  y2: "0"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "0%",
  "stop-color": "#7B869D",
  "stop-opacity": "1"
}), /*#__PURE__*/(0, _vue.createElementVNode)("stop", {
  offset: "100%",
  "stop-color": "#7B869D",
  "stop-opacity": "1"
})])], -1);

var _hoisted_5 = /*#__PURE__*/(0, _vue.createElementVNode)("circle", {
  fill: "#7B869D",
  cx: "45%",
  cy: "0",
  r: "7.5"
}, null, -1);

var _hoisted_6 = /*#__PURE__*/(0, _vue.createElementVNode)("g", {
  fill: "none",
  "stroke-width": "20",
  transform: "translate(100,100)"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("path", {
  d: "M 0,-100 A 100,100 0 0,1 86.6,-50",
  stroke: "url(#spinner-color-1)"
}), /*#__PURE__*/(0, _vue.createElementVNode)("path", {
  d: "M 86.6,-50 A 100,100 0 0,1 86.6,50",
  stroke: "url(#spinner-color-2)"
}), /*#__PURE__*/(0, _vue.createElementVNode)("path", {
  d: "M 86.6,50 A 100,100 0 0,1 0,100",
  stroke: "url(#spinner-color-3)"
}), /*#__PURE__*/(0, _vue.createElementVNode)("path", {
  d: "M 0,100 A 100,100 0 0,1 -86.6,50",
  stroke: "url(#spinner-color-4)"
}), /*#__PURE__*/(0, _vue.createElementVNode)("path", {
  d: "M -86.6,50 A 100,100 0 0,1 -86.6,-50",
  stroke: "url(#spinner-color-5)"
}), /*#__PURE__*/(0, _vue.createElementVNode)("path", {
  d: "M -86.6,-50 A 100,100 0 0,1 0,-100",
  stroke: "url(#spinner-color-6)"
})], -1);

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0, _vue.openBlock)(), (0, _vue.createBlock)(_vue.Transition, {
    name: "fade"
  }, {
    default: (0, _vue.withCtx)(function () {
      return [$props.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [(0, _vue.createElementVNode)("div", _hoisted_2, [((0, _vue.openBlock)(), (0, _vue.createElementBlock)("svg", _hoisted_3, [(0, _vue.createElementVNode)("title", null, (0, _vue.toDisplayString)(_ctx.$t("Loading")), 1), _hoisted_4, _hoisted_5, _hoisted_6]))])])) : (0, _vue.createCommentVNode)("", true)];
    }, undefined, true),
    _: 1
  });
}

/***/ }),

/***/ "1928":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("4ea4");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__("a34a"));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__("c973"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("9523"));

var _axios = _interopRequireDefault(__webpack_require__("bc3a"));

var _FolderParent = _interopRequireDefault(__webpack_require__("a44a"));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__("d76c"));

var _myContentApi = __webpack_require__("41f6");

var _nebulaComponents = __webpack_require__("444c");

var _store = _interopRequireDefault(__webpack_require__("4360"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _default = {
  name: 'MyContentModal',
  components: {
    NebulaButton: _nebulaComponents.NebulaButton,
    NebulaModal: _nebulaComponents.NebulaModal,
    NebulaTabs: _nebulaComponents.NebulaTabs,
    NebulaTabItem: _nebulaComponents.NebulaTabItem,
    FolderParent: _FolderParent.default,
    LoadingSpinner: _LoadingSpinner.default
  },
  emits: ['chooseAssets', 'closeModal', 'success-add-asset-to-folder', 'success-copy-asset-to-folder', 'success-move-asset-to-trash', 'asset-moved-or-copied', 'success-move-asset-to-trash', 'asset-restored'],
  data: function data() {
    return {
      actionPending: null,
      selectedTab: {
        type: 'user',
        label: this.$t('My Content')
      },
      localUploadToken: null
    };
  },
  computed: {
    enableMoveToTrash: function enableMoveToTrash() {
      var _this$asset;

      return !this.config.enableAddAction && ((_this$asset = this.asset) === null || _this$asset === void 0 ? void 0 : _this$asset.actions[0]) === 'trash';
    },
    modalIsActive: function modalIsActive() {
      return this.myContentModalStore.modalIsActive;
    },
    loadingFolders: function loadingFolders() {
      return this.myContentModalStore.loadingFolders;
    },
    selectedAssets: function selectedAssets() {
      return this.myContentModalStore.selectedAssets;
    },
    removeItemText: function removeItemText() {
      var message = {
        chunk1: this.$t('Are you sure you want to move'),
        chunk2: "<span class=\"my-content--bold-text\">".concat(this.asset.selectedAssetTitle, "</span>"),
        chunk3: this.$t('to your trash?')
      };
      return "".concat(message.chunk1, " ").concat(message.chunk2, " ").concat(message.chunk3);
    },
    isMoveToTrash: function isMoveToTrash() {
      var _this$asset2, _this$asset2$actions;

      // Use `move-to-my-content-trash-modal`
      return (_this$asset2 = this.asset) === null || _this$asset2 === void 0 ? void 0 : (_this$asset2$actions = _this$asset2.actions) === null || _this$asset2$actions === void 0 ? void 0 : _this$asset2$actions.includes('trash');
    },
    normalizeEnableAddAction: function normalizeEnableAddAction() {
      var _this$config, _this$config2;

      // nested props data with default value returns undefined
      // if it `this.config?.enableAddAction` returns undefined,
      //  we assume a default 'add' action is enabled by default
      return typeof ((_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.enableAddAction) === 'undefined' || ((_this$config2 = this.config) === null || _this$config2 === void 0 ? void 0 : _this$config2.enableAddAction);
    },
    useAddAction: function useAddAction() {
      return this.normalizeEnableAddAction && !this.isMoveToTrash && !this.isChooseModal && !this.isFromMyContent;
    },
    chooseActions: function chooseActions() {
      return [{
        type: 'choose',
        label: this.$t('Choose'),
        method: 'chooseAssets'
      }];
    },
    isChooseModal: function isChooseModal() {
      return this.config.modalType === 'choose';
    },
    isStudent: function isStudent() {
      // Learn and Suite have initData available on the window. Apps without initData
      // can pass this in as a prop. If either is true, the user is a student
      return this.config.isStudent || window.initData && window.initData.user.is_student;
    },
    isFromMyContent: function isFromMyContent() {
      return this.asset && this.asset.requestingResource === 'myContent';
    },
    isImagesOnly: function isImagesOnly() {
      return this.config.imagesOnly;
    },
    modalDataIsValid: function modalDataIsValid() {
      /**
       * Prevent modal from rendering at all if we've passed it buggy data.
       * This component's data is coupled in a complex way with Suite's
       * 'myContent' Vuex module. The way it gets rendered is also different
       * from app to app. FED-466 as been opened to remove the dependency
       * on Vuex or otherwise to try to standardize this. In the meantime
       * just don't show the modal if the different Vuex configs are getting
       * in each other's way
       */
      return this.isChooseModal || this.subHeadingCopy;
    },
    myContentActions: function myContentActions() {
      return [{
        type: 'move',
        label: this.$t('Move'),
        pendingLabel: this.$t('Moving...'),
        method: 'handleMoveAssetToFolder'
      }, {
        type: 'copy',
        label: this.$t('Copy'),
        pendingLabel: this.$t('Copying...'),
        method: 'handleCopyAssetToFolder'
      }, {
        type: 'restore',
        label: this.$t('Restore'),
        pendingLabel: this.$t('Restoring...'),
        method: 'handleRestoreAssetToFolder'
      }, {
        type: 'trash',
        label: this.$t('Move to trash'),
        pendingLabel: this.$t('Moving to trash...'),
        method: 'handleMoveAssetToTrashFolder'
      }];
    },
    tabs: function tabs() {
      return [{
        type: 'user',
        label: this.$t('My Content')
      }, {
        type: 'site',
        label: this.$t('School Content')
      }, {
        type: 'account',
        label: this.$t('District Content')
      }];
    },
    hideDistrictTab: function hideDistrictTab() {
      // Learn and Suite have initData available on the window. Apps without initData
      // can pass this in as a prop. If either is true, hide the district tab
      return this.config.hideDistrictTab || window.initData && window.initData.hide_district_tab;
    },
    hideSchoolAndDistrict: function hideSchoolAndDistrict() {
      return this.asset && !this.asset.sharingEnabled || this.isStudent;
    },
    filteredTabs: function filteredTabs() {
      if (this.hideSchoolAndDistrict) {
        return this.tabs.filter(function (tab) {
          return tab.type === 'user';
        });
      }

      if (this.hideDistrictTab) {
        return this.tabs.filter(function (tab) {
          return tab.type !== 'account';
        });
      }

      return this.tabs;
    },
    availableActions: function availableActions() {
      var _this = this;

      if (this.isChooseModal) return this.chooseActions;
      var assetActions = this.asset.actions || [];
      return this.myContentActions.filter(function (action) {
        return assetActions.includes(action.type) && _this.getActionTabRestrictions(action.type);
      });
    },
    bulkCopy: function bulkCopy() {
      var itemCount = this.asset.bulk && this.asset.bulk.assets.length;
      return this.$t('%(num)d items', {
        num: itemCount
      });
    },
    headingCopy: function headingCopy() {
      if (this.enableMoveToTrash) {
        return this.$t('Move to trash');
      }

      if (this.config.modalType === 'choose') {
        return this.$t('Choose from My Content');
      }

      if (!this.isFromMyContent) {
        return this.$t('Save');
      } // Make a heading like "Move" or "Move/Copy"


      return this.availableActions.map(function (action) {
        return action.label;
      }).join('/');
    },
    subHeadingCopy: function subHeadingCopy() {
      return this.asset.bulk ? this.bulkCopy : this.asset.selectedAssetTitle;
    }
  },
  setup: function setup() {
    return {
      myContentModalStore: _store.default
    };
  },
  created: function created() {
    var _this2 = this;

    // this expecting the parent app to have a store on the Vue instance.
    // {this} reference to parent Vue instance
    if (this.config.baseURL) {
      // By default requests use the apiproxy, but other domains may need to use a different
      // api base url to avoid CORS issues
      _myContentApi.myContentApi.interceptors.request.use(function (config) {
        return _objectSpread(_objectSpread({}, config), {}, {
          baseURL: _this2.config.baseURL
        });
      });
    }

    this.myContentModalStore.setNebulaIcon(this.config.nebulaSvg);
    this.myContentModalStore.showModal(this.config.isActive);
  },
  mounted: function mounted() {
    this.initOrCloseModal();
  },
  beforeUnmount: function beforeUnmount() {
    this.focusOnTrigger();
  },
  methods: {
    chooseAssets: function chooseAssets() {
      this.$emit('chooseAssets', this.selectedAssets);
    },
    initModal: function initModal() {
      var payload = {
        config: _objectSpread(_objectSpread({}, this.config), {}, {
          tab: this.selectedTab
        }),
        isChooseModal: this.isChooseModal
      };
      this.myContentModalStore.initMyContent(payload);
    },
    getActionTabRestrictions: function getActionTabRestrictions(type) {
      if ((type === 'move' || type === 'restore') && !this.asset.sharingEnabled) {
        return this.asset.currentTab === this.selectedTab.type;
      }

      return true;
    },
    initOrCloseModal: function initOrCloseModal() {
      if (this.config.isActive) {
        this.initModal();
      } else {
        this.closeModal();
      }
    },
    addNewFolder: function addNewFolder() {
      this.myContentModalStore.showAddNewFolder(true);
    },
    getUploadUrl: function getUploadUrl() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var baseURL, myContentResponse, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                baseURL = '/apiproxy/v1/';

                if (_this3.localUploadToken) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return (0, _myContentApi.getMyContent)({
                  baseURL: baseURL
                });

              case 4:
                myContentResponse = _context.sent;
                _this3.localUploadToken = myContentResponse.tokens.upload;

              case 6:
                _context.next = 8;
                return (0, _myContentApi.getUploadUrlApi)({
                  baseURL: baseURL,
                  folderId: _this3.myContentModalStore.selectedFolder,
                  filename: _this3.asset.filename,
                  contentType: 'image/png',
                  token: _this3.localUploadToken
                });

              case 8:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleAddAssetToFolder: function handleAddAssetToFolder() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var payload, _payload;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.actionPending = 'add';

                if (!_this4.asset.createdAsset) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return _this4.addCreatedAssetToFolder();

              case 4:
                _this4.actionPending = null;
                _context2.next = 27;
                break;

              case 7:
                if (!_this4.asset.bulk) {
                  _context2.next = 15;
                  break;
                }

                payload = {
                  folderId: _this4.myContentModalStore.selectedFolder,
                  bulkAssets: _this4.asset.bulk.assets,
                  tab: 'user',
                  token: _this4.asset.bulk.token
                };
                _context2.next = 11;
                return (0, _myContentApi.addBulkAssetsToFolder)(payload);

              case 11:
                _this4.actionPending = null;

                _this4.closeModal();

                _context2.next = 27;
                break;

              case 15:
                _payload = {
                  folderId: _this4.myContentModalStore.selectedFolder,
                  assetId: _this4.asset.selectedAssetId,
                  tab: _this4.selectedTab.type
                };
                _this4.actionPending = null;
                _context2.prev = 17;
                _context2.next = 20;
                return _this4.myContentModalStore.addAssetToFolder(_payload);

              case 20:
                _this4.$emit('success-add-asset-to-folder', _payload);

                _this4.closeModal();

                _context2.next = 27;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](17);
                window.console.log(_context2.t0);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[17, 24]]);
      }))();
    },
    addCreatedAssetToFolder: function addCreatedAssetToFolder() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var response, asset, fields, url, uploadData;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.getUploadUrl();

              case 2:
                response = _context3.sent;
                asset = response.asset, fields = response.fields, url = response.url;
                uploadData = new FormData();
                Object.keys(fields).forEach(function (key) {
                  uploadData.append(key, fields[key]);
                });
                uploadData.append('file', _this5.b64toBlob(_this5.asset.base64Img));

                _this5.uploadFile(url, uploadData);

                _this5.actionPending = null;

                _this5.closeModal();

                return _context3.abrupt("return", asset);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     *  In math tools, a user-generated image returns a base64 string.
     *  We then need to turn that string into a blob to upload.
     */
    b64toBlob: function b64toBlob(b64Data) {
      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i += 1) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {
        type: contentType
      });
      return blob;
    },
    uploadFile: function uploadFile(url, formData) {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var response;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return (0, _axios.default)({
                  method: 'post',
                  url: url,
                  data: formData,
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 3:
                response = _context4.sent;
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                // TODO: implement error states for modal
                window.console.log('error: ', _context4.t0);

              case 9:
                return _context4.abrupt("return", response);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 6]]);
      }))();
    },
    handleCopyAssetToFolder: function handleCopyAssetToFolder() {
      var _this6 = this;

      var payload = {
        targetFolderId: this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type
      };
      this.actionPending = 'copy';
      this.myContentModalStore.copyAssetToFolder(payload).then(function () {
        _this6.$emit('success-copy-asset-to-folder');

        _this6.$emit('asset-moved-or-copied');

        _this6.actionPending = null;
      });
    },
    handleMoveAssetToFolder: function handleMoveAssetToFolder() {
      var _this7 = this;

      var payload = {
        targetFolderId: this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type,
        currentFolderId: this.asset.parentFolderId
      };
      this.actionPending = 'move';
      this.myContentModalStore.moveAssetToFolder(payload).then(function () {
        _this7.$emit('asset-moved-or-copied');

        _this7.actionPending = null;
      });
    },
    handleMoveAssetToTrashFolder: function handleMoveAssetToTrashFolder() {
      var _this8 = this;

      var payload = {
        targetFolderId: this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type,
        currentFolderId: this.asset.parentFolderId
      };
      this.actionPending = 'trash';
      this.myContentModalStore.moveAssetToTrash(payload).then(function () {
        _this8.$emit('success-move-asset-to-trash');

        _this8.actionPending = null;
      });
    },
    handleRestoreAssetToFolder: function handleRestoreAssetToFolder() {
      var _this9 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var config;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                config = {
                  folderId: _this9.myContentModalStore.selectedFolder === 'root' ? '' : _this9.myContentModalStore.selectedFolder,
                  assetId: _this9.asset.selectedAssetId,
                  tab: _this9.selectedTab.type
                };
                _this9.actionPending = 'restore';

                _this9.myContentModalStore.restoreAssetFromTrash(config).then(function () {
                  _this9.$emit('asset-restored');

                  _this9.actionPending = null;
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    closeModal: function closeModal() {
      var _this10 = this;

      this.myContentModalStore.showModal(false);
      this.$nextTick(function () {
        _this10.$emit('closeModal');
      });
    },
    focusOnTrigger: function focusOnTrigger() {
      if (this.asset) {
        var selectedAssetId = this.asset.selectedAssetId;
        var triggerButton = document.getElementById("action-menu--".concat(selectedAssetId));

        if (triggerButton) {
          triggerButton.focus();
        }
      }
    },
    setSelectedTab: function setSelectedTab(type) {
      this.selectedTab = this.tabs.find(function (tab) {
        return tab.type === type;
      });
    },
    isSelected: function isSelected(type) {
      return this.selectedTab && this.selectedTab.type === type;
    },
    getActionLabel: function getActionLabel(action) {
      return this.actionPending === action.type ? action.pendingLabel : action.label;
    },
    handleClick: function handleClick(method) {
      this[method]();
    },
    getInitialFocusElement: function getInitialFocusElement() {
      var _this$$refs, _this$$refs$tabButton, _this$$refs2;

      return (_this$$refs = this.$refs) !== null && _this$$refs !== void 0 && (_this$$refs$tabButton = _this$$refs.tabButtons) !== null && _this$$refs$tabButton !== void 0 && _this$$refs$tabButton.length ? this.$refs.tabButtons[0] : (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : _this$$refs2.closeButton;
    }
  },
  props: {
    asset: {
      selectedAssetId: {
        type: String
      },
      selectedAssetTitle: {
        type: String
      },
      parentFolderId: {
        type: String
      },
      actions: {
        type: Array
      },
      requestingResource: {
        type: String
      },
      sharingEnabled: {
        type: Boolean
      },
      currentTab: {
        type: String
      },
      bulk: {
        type: Object
      }
    },
    config: {
      baseURL: {
        type: String,
        required: false
      },
      hideDistrictTab: Boolean,
      isActive: Boolean,
      isStudent: Boolean,
      modalType: {
        type: String,
        required: false
      },
      nebulaSvg: {
        type: String,
        required: true
      },
      type: Object,
      selectMultiple: {
        type: Boolean,
        default: true
      },
      imagesOnly: {
        type: Boolean,
        default: false
      },
      enableAddAction: {
        type: Boolean,
        default: true
      }
    }
  },
  watch: {
    config: {
      handler: function handler() {
        this.initOrCloseModal();
      },
      deep: true
    },
    asset: {
      handler: function handler() {
        this.initOrCloseModal();
      },
      deep: true
    },
    selectedTab: function selectedTab() {
      this.initOrCloseModal();
    },
    modalIsActive: function modalIsActive() {
      var _this11 = this;

      // Only a modal opened from My Content can have an initial tab other than the default selectedTab when opened.
      if (this.modalIsActive && this.isFromMyContent) {
        this.selectedTab = this.tabs.find(function (tab) {
          return tab.type === _this11.asset.currentTab;
        });
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "1ad9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("164b");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0__, "render")) __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0__["render"]; });



/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "1eb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* unused harmony default export */ var _unused_webpack_default_export = (null);


/***/ }),

/***/ "20e0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

var _vue = __webpack_require__("8bbf");

var _hoisted_1 = ["xlink:href"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("svg", {
    class: (0, _vue.normalizeClass)($options.className),
    "aria-hidden": "true",
    focusable: "false"
  }, [(0, _vue.createElementVNode)("use", {
    "xlink:href": $options.href
  }, null, 8, _hoisted_1)], 2);
}

/***/ }),

/***/ "2236":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("5a43");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "2349":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_style_index_0_id_40b95082_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d74a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_style_index_0_id_40b95082_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_style_index_0_id_40b95082_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");
var enhanceError = __webpack_require__("387f");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2658":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("332d");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 

/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "2ebf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("acec");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("e1982184", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "332d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("4ea4");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _store = _interopRequireDefault(__webpack_require__("4360"));

var _default = {
  name: 'NebulaIcon',
  computed: {
    className: function className() {
      return this.classOverride ? this.classOverride : "comet-icon--".concat(this.size);
    },
    href: function href() {
      return "".concat(_store.default.nebulaIconSvg, "#").concat(this.symbolId);
    }
  },
  props: {
    classOverride: {
      required: false
    },
    size: {
      default: 'l',
      // Comet icons default to 24px
      required: false,
      type: String
    },
    symbolId: {
      required: true,
      type: String
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "3b38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("05e7");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0__, "render")) __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0__["render"]; });



/***/ }),

/***/ "3d2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6cc2");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 

/***/ }),

/***/ "3f83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1928");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 

/***/ }),

/***/ "41f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("4ea4");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMyContent = getMyContent;
exports.getUploadUrlApi = getUploadUrlApi;
exports.getMyContentNestedFolder = getMyContentNestedFolder;
exports.addNewFolder = addNewFolder;
exports.addAssetToRootFolder = addAssetToRootFolder;
exports.addAssetToExistingFolder = addAssetToExistingFolder;
exports.addBulkAssetsToFolder = addBulkAssetsToFolder;
exports.copyAssetToExistingFolder = copyAssetToExistingFolder;
exports.moveAssetToExistingFolder = moveAssetToExistingFolder;
exports.restoreAsset = restoreAsset;
exports.moveAssetToTrash = moveAssetToTrash;
exports.default = exports.myContentApi = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__("a34a"));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__("c973"));

var _axios = _interopRequireDefault(__webpack_require__("bc3a"));

var myContentApi = _axios.default.create({
  baseURL: '/apiproxy/v1'
});

exports.myContentApi = myContentApi;

function getMyContent(_x) {
  return _getMyContent.apply(this, arguments);
}

function _getMyContent() {
  _getMyContent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(config) {
    var rootOwner, folderId, sort, rootType, page, payload, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rootOwner = config.rootOwner, folderId = config.folderId, sort = config.sort, rootType = config.rootType, page = config.page;
            payload = {
              crossDomain: true,
              withCredentials: true,
              params: {
                root_owner: rootOwner || 'user',
                folder_id: folderId || null,
                sort: sort || null,
                group: null,
                root_folder_type: rootType || null,
                page: page || null
              }
            };
            _context.next = 4;
            return myContentApi.get('/mycontent', payload);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getMyContent.apply(this, arguments);
}

function getUploadUrlApi(_x2) {
  return _getUploadUrlApi.apply(this, arguments);
}

function _getUploadUrlApi() {
  _getUploadUrlApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref) {
    var baseURL, folderId, filename, contentType, token, url, payload, config, response;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            baseURL = _ref.baseURL, folderId = _ref.folderId, filename = _ref.filename, contentType = _ref.contentType, token = _ref.token;
            url = '/mycontent/get_upload_url';
            payload = {
              file_name: filename,
              folder_id: folderId,
              content_type: contentType
            };
            config = {
              baseURL: baseURL || '/apiproxy/v1',
              headers: {
                'X-Token': token
              },
              withCredentials: true
            };
            _context2.prev = 4;
            _context2.next = 7;
            return _axios.default.post(url, payload, config);

          case 7:
            response = _context2.sent;
            _context2.next = 13;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);
            response = _context2.t0;

          case 13:
            return _context2.abrupt("return", response);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _getUploadUrlApi.apply(this, arguments);
}

function getMyContentNestedFolder() {
  return _getMyContentNestedFolder.apply(this, arguments);
}

function _getMyContentNestedFolder() {
  _getMyContentNestedFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var folderId,
        tab,
        queryId,
        url,
        response,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            folderId = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
            tab = _args3.length > 1 ? _args3[1] : undefined;
            queryId = folderId ? "&folder_id=".concat(folderId) : '';
            url = "/mycontent/folders?root_folder_type_id=2".concat(queryId, "&current_tab=").concat(tab);
            _context3.next = 6;
            return myContentApi.get(url, {
              crossDomain: true,
              withCredentials: true
            });

          case 6:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getMyContentNestedFolder.apply(this, arguments);
}

function addNewFolder(_x3) {
  return _addNewFolder.apply(this, arguments);
}

function _addNewFolder() {
  _addNewFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(_ref2) {
    var folderParentId, title, tab, token, url, payload, config, response;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            folderParentId = _ref2.folderParentId, title = _ref2.title, tab = _ref2.tab, token = _ref2.token;
            url = '/mycontent/folder/add';
            payload = {
              parent_folder_id: folderParentId,
              title: title,
              current_tab: tab
            };
            config = {
              headers: {
                'X-Token': token
              },
              withCredentials: true
            };
            _context4.next = 6;
            return myContentApi.post(url, payload, config);

          case 6:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _addNewFolder.apply(this, arguments);
}

function addAssetToRootFolder(_x4) {
  return _addAssetToRootFolder.apply(this, arguments);
}

function _addAssetToRootFolder() {
  _addAssetToRootFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(_ref3) {
    var assetId, tab, token, url, config, response;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            assetId = _ref3.assetId, tab = _ref3.tab, token = _ref3.token;
            url = "/mycontent/folder/add/".concat(assetId, "?current_tab=").concat(tab);
            config = {
              headers: {
                'X-Token': token
              },
              withCredentials: true
            };
            _context5.next = 5;
            return myContentApi.post(url, {}, config);

          case 5:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _addAssetToRootFolder.apply(this, arguments);
}

function addAssetToExistingFolder(_x5) {
  return _addAssetToExistingFolder.apply(this, arguments);
}

function _addAssetToExistingFolder() {
  _addAssetToExistingFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(_ref4) {
    var folderId, assetId, tab, token, url, config, response;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            folderId = _ref4.folderId, assetId = _ref4.assetId, tab = _ref4.tab, token = _ref4.token;
            url = "/mycontent/folder/".concat(folderId, "/add/").concat(assetId, "?current_tab=").concat(tab);
            config = {
              headers: {
                'X-Token': token
              },
              withCredentials: true
            };
            _context6.next = 5;
            return myContentApi.post(url, {}, config);

          case 5:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _addAssetToExistingFolder.apply(this, arguments);
}

function addBulkAssetsToFolder(_x6) {
  return _addBulkAssetsToFolder.apply(this, arguments);
}

function _addBulkAssetsToFolder() {
  _addBulkAssetsToFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(_ref5) {
    var folderId, bulkAssets, tab, token, url, payload, config, response;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            folderId = _ref5.folderId, bulkAssets = _ref5.bulkAssets, tab = _ref5.tab, token = _ref5.token;
            url = "/mycontent/folder/".concat(folderId, "/add_many");
            payload = {
              current_tab: tab,
              resource_ids: bulkAssets
            };
            config = {
              headers: {
                'X-Token': token
              },
              withCredentials: true
            };
            _context7.next = 6;
            return myContentApi.post(url, payload, config);

          case 6:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _addBulkAssetsToFolder.apply(this, arguments);
}

function copyAssetToExistingFolder(_x7) {
  return _copyAssetToExistingFolder.apply(this, arguments);
}

function _copyAssetToExistingFolder() {
  _copyAssetToExistingFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(_ref6) {
    var targetFolderId, assetId, tab, token, url, payload, config, response;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            targetFolderId = _ref6.targetFolderId, assetId = _ref6.assetId, tab = _ref6.tab, token = _ref6.token;
            url = "/mycontent/folder/copy/".concat(assetId);
            payload = {
              current_tab: tab,
              target_tab: tab,
              target_folder_id: targetFolderId === 'root' ? null : targetFolderId
            };
            config = {
              headers: {
                'X-Token': token
              }
            };
            _context8.next = 6;
            return myContentApi.post(url, payload, config);

          case 6:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _copyAssetToExistingFolder.apply(this, arguments);
}

function moveAssetToExistingFolder(_x8) {
  return _moveAssetToExistingFolder.apply(this, arguments);
}

function _moveAssetToExistingFolder() {
  _moveAssetToExistingFolder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(_ref7) {
    var targetFolderId, currentFolderId, assetId, tab, token, url, payload, config, response;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            targetFolderId = _ref7.targetFolderId, currentFolderId = _ref7.currentFolderId, assetId = _ref7.assetId, tab = _ref7.tab, token = _ref7.token;
            url = '/mycontent/folder/move';
            payload = {
              current_tab: tab,
              target_tab: tab,
              current_folder_id: currentFolderId,
              target_folder_id: targetFolderId,
              resource_id: assetId
            };
            config = {
              headers: {
                'X-Token': token
              }
            };
            _context9.next = 6;
            return myContentApi.post(url, payload, config);

          case 6:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 8:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _moveAssetToExistingFolder.apply(this, arguments);
}

function restoreAsset(_x9, _x10, _x11, _x12) {
  return _restoreAsset.apply(this, arguments);
}

function _restoreAsset() {
  _restoreAsset = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(folderId, assetId, tab, token) {
    var url, config, payload, response;
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            url = "/mycontent/folder/move/".concat(assetId, "/restore");
            config = {
              headers: {
                'X-Token': token
              }
            };
            payload = {
              current_folder_id: folderId,
              current_tab: tab
            };
            _context10.next = 5;
            return myContentApi.post(url, payload, config);

          case 5:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _restoreAsset.apply(this, arguments);
}

function moveAssetToTrash(_x13) {
  return _moveAssetToTrash.apply(this, arguments);
}

function _moveAssetToTrash() {
  _moveAssetToTrash = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(_ref8) {
    var assetId, currentFolderId, tab, token, url, config, payload, response;
    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            assetId = _ref8.assetId, currentFolderId = _ref8.currentFolderId, tab = _ref8.tab, token = _ref8.token;
            url = "/apiproxy/v1/mycontent/folder/move/".concat(assetId, "/trash");
            config = {
              headers: {
                'X-Token': token
              }
            };
            payload = {
              current_folder_id: currentFolderId,
              current_tab: tab
            };
            _context11.next = 6;
            return _axios.default.post(url, payload, config);

          case 6:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 8:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _moveAssetToTrash.apply(this, arguments);
}

var _default = {
  getUploadUrlApi: getUploadUrlApi,
  getMyContentNestedFolder: getMyContentNestedFolder,
  addNewFolder: addNewFolder,
  addAssetToExistingFolder: addAssetToExistingFolder,
  addAssetToRootFolder: addAssetToRootFolder,
  copyAssetToExistingFolder: copyAssetToExistingFolder,
  moveAssetToExistingFolder: moveAssetToExistingFolder,
  restoreAsset: restoreAsset,
  moveAssetToTrash: moveAssetToTrash
};
exports.default = _default;

/***/ }),

/***/ "4360":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("4ea4");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__("a34a"));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__("c973"));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__("448a"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("9523"));

var _vue = __webpack_require__("8bbf");

var _myContentApi = __webpack_require__("41f6");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Add an empty children array to folders, which gets populated if the user opens it up.
var prepFolderData = function prepFolderData(data) {
  return data.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      children: child.type && child.type.id !== '89cb88bc-1b04-4de2-8986-e82f65df2755' ? undefined : [],
      paging: null // the paging property needs to be set here so it can be reactive later

    });
  });
}; // Recursive funtion, takes root,id of current folder &
// list of sub-folders.
// This function recursively check for the selected folder with the
// id passed in and append its fetched children


var modifyNestedState = function modifyNestedState(root, _ref) {
  var appendItems = _ref.appendItems,
      id = _ref.id,
      children = _ref.children,
      paging = _ref.paging;

  if (root.id === id) {
    /* eslint-disable no-param-reassign */
    root.children = appendItems ? [].concat((0, _toConsumableArray2.default)(root.children), (0, _toConsumableArray2.default)(children)) : (0, _toConsumableArray2.default)(children);
    root.paging = paging;
    /* eslint-enable no-param-reassign */
  } else if (root.children) {
    root.children.forEach(function (child) {
      modifyNestedState(child, {
        appendItems: appendItems,
        id: id,
        children: children,
        paging: paging
      });
    });
  }
};

var myContentModalStore = (0, _vue.reactive)({
  // State
  modalIsActive: false,
  selectMultiple: false,
  selectedAssets: [],
  selectedFolder: null,
  isCreatingNewFolder: false,
  nebulaIconSvg: null,
  type: {
    isTypeAdd: false,
    isTypeCopy: false,
    isTypeMove: false,
    isTypeRestore: false
  },
  tokens: {
    add: null,
    copy: null,
    move: null,
    create: null,
    addToRootFolderToken: null,
    restore: null
  },
  myUploadsFolder: {
    children: [],
    title: 'My Uploads',
    root: true,
    id: null,
    paging: null
  },
  rootFolder: {
    children: [],
    title: 'My Content',
    root: true,
    id: 'root',
    paging: null
  },
  rootFolderIds: null,
  loadingFolders: false,
  // Actions
  initMyContent: function initMyContent(_ref2) {
    var _this = this;

    var config = _ref2.config,
        isChooseModal = _ref2.isChooseModal;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var tab, isActive, selectMultiple, myContentResponse, myUploadsResponse;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tab = config.tab, isActive = config.isActive, selectMultiple = config.selectMultiple;

              _this.showModal(isActive);

              _this.loadingFolders = true;

              if (!isChooseModal) {
                _context.next = 15;
                break;
              }

              _context.next = 6;
              return (0, _myContentApi.getMyContent)({
                rootOwner: tab.type
              });

            case 6:
              myContentResponse = _context.sent;

              if (!(tab.type === 'user')) {
                _context.next = 11;
                break;
              }

              _context.next = 10;
              return (0, _myContentApi.getMyContent)({
                rootType: 5
              });

            case 10:
              myUploadsResponse = _context.sent;

            case 11:
              _this.setInitMyContent({
                rootFolder: {
                  paging: myContentResponse.paging,
                  children: prepFolderData(myContentResponse.mycontent)
                },
                myUploadsFolder: {
                  paging: myUploadsResponse ? myUploadsResponse.paging : {},
                  children: myUploadsResponse ? prepFolderData(myUploadsResponse.mycontent) : [],
                  id: myUploadsResponse && myUploadsResponse.folder_id
                },
                tab: tab.label,
                id: myContentResponse.folder_id,
                selectMultiple: selectMultiple
              });

              _this.loadingFolders = false;
              _this.selectedFolder = myContentResponse.folder_id;
              return _context.abrupt("return", true);

            case 15:
              return _context.abrupt("return", (0, _myContentApi.getMyContentNestedFolder)(null, tab.type).then(function (data) {
                var tokens = {
                  addToken: data.tokens.add_to_folder,
                  createToken: data.tokens.create,
                  copyToken: data.tokens.copy,
                  moveToken: data.tokens.move,
                  restoreToken: data.tokens.restore,
                  addToRootFolderToken: data.tokens.add_to_root_my_content_folder,
                  moveToTrashToken: data.tokens.trash
                };
                var rootFolderIds = data.root_folder_ids;

                if (!_this.rootFolderIds) {
                  _this.rootFolderIds = rootFolderIds;
                }

                var dataConfig = {
                  rootFolder: {
                    children: data.folders.length ? prepFolderData(data.folders) : []
                  },
                  tab: tab.label,
                  id: rootFolderIds[tab.type]
                };

                _this.setInitMyContent(dataConfig);

                _this.setTokens(tokens);

                _this.loadingFolders = false;
                _this.selectedFolder = rootFolderIds[tab.type];
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  fetchNestedFolder: function fetchNestedFolder(_ref4) {
    var _this2 = this;

    var id = _ref4.id,
        isChooseModal = _ref4.isChooseModal,
        page = _ref4.page,
        tab = _ref4.tab;

    try {
      if (isChooseModal) {
        // For the Choose modal, get nested folders AND assets
        return (0, _myContentApi.getMyContent)({
          folderId: id,
          page: page,
          rootOwner: tab,
          rootType: id === this.myUploadsFolder.id ? 5 : undefined
        }).then(function (data) {
          _this2.setFolderChild({
            appendItems: !!page,
            id: id,
            children: prepFolderData(data.mycontent),
            paging: data.paging
          });
        });
      }

      return (0, _myContentApi.getMyContentNestedFolder)(id, tab).then(function (data) {
        _this2.setFolderChild({
          id: id,
          children: prepFolderData(data.folders)
        });
      });
    } catch (_unused) {
      return null;
    }
  },
  setFolderChild: function setFolderChild(payload) {
    if (this.myUploadsFolder.id) {
      // The My Uploads folder exists outside of the normal "root" structure,
      // so it needs to be checked on its own
      modifyNestedState(this.myUploadsFolder, payload);
    }

    modifyNestedState(this.rootFolder, payload);
  },
  setTokens: function setTokens(data) {
    this.tokens.add = data.addToken;
    this.tokens.create = data.createToken;
    this.tokens.copy = data.copyToken;
    this.tokens.move = data.moveToken;
    this.tokens.restore = data.restoreToken;
    this.tokens.addToRootFolderToken = data.addToRootFolderToken;
    this.tokens.trash = data.moveToTrashToken;
  },
  addNewContentFolder: function addNewContentFolder(_ref5) {
    var _this3 = this;

    var folderParentId = _ref5.folderParentId,
        title = _ref5.title,
        tab = _ref5.tab;
    return (0, _myContentApi.addNewFolder)({
      folderParentId: folderParentId,
      title: title,
      token: this.tokens.create,
      tab: tab
    }).then(function () {
      _this3.fetchNestedFolder({
        id: folderParentId,
        tab: tab
      });

      _this3.showAddNewFolder(false);
    });
  },
  addAssetToFolder: function addAssetToFolder(_ref6) {
    var _this4 = this;

    var folderId = _ref6.folderId,
        assetId = _ref6.assetId,
        tab = _ref6.tab;

    if (folderId === 'root') {
      return (0, _myContentApi.addAssetToRootFolder)({
        assetId: assetId,
        tab: tab,
        token: this.tokens.addToRootFolderToken
      }).then(function () {
        _this4.modalIsActive = false;
      });
    }

    return (0, _myContentApi.addAssetToExistingFolder)({
      folderId: folderId,
      assetId: assetId,
      tab: tab,
      token: this.tokens.add
    }).then(function () {
      _this4.modalIsActive = false;
    });
  },
  copyAssetToFolder: function copyAssetToFolder(_ref7) {
    var _this5 = this;

    var targetFolderId = _ref7.targetFolderId,
        assetId = _ref7.assetId,
        tab = _ref7.tab;
    return (0, _myContentApi.copyAssetToExistingFolder)({
      targetFolderId: targetFolderId,
      assetId: assetId,
      tab: tab,
      token: this.tokens.copy
    }).then(function () {
      _this5.modalIsActive = false;
    });
  },
  moveAssetToFolder: function moveAssetToFolder(_ref8) {
    var _this6 = this;

    var targetFolderId = _ref8.targetFolderId,
        currentFolderId = _ref8.currentFolderId,
        assetId = _ref8.assetId,
        tab = _ref8.tab;
    return (0, _myContentApi.moveAssetToExistingFolder)({
      targetFolderId: targetFolderId,
      currentFolderId: currentFolderId,
      assetId: assetId,
      tab: tab,
      token: this.tokens.move
    }).then(function () {
      _this6.modalIsActive = false;
    });
  },
  moveAssetToTrash: function moveAssetToTrash(payload) {
    var _this7 = this;

    var assetId = payload.assetId,
        currentFolderId = payload.currentFolderId,
        tab = payload.tab;
    return (0, _myContentApi.moveAssetToTrash)({
      currentFolderId: currentFolderId,
      assetId: assetId,
      tab: tab,
      token: this.tokens.trash
    }).then(function () {
      _this7.modalIsActive = false;
    });
  },
  restoreAssetFromTrash: function restoreAssetFromTrash(data) {
    var _this8 = this;

    var folderId = data.folderId,
        assetId = data.assetId,
        tab = data.tab;
    return (0, _myContentApi.getMyContentNestedFolder)(folderId, tab).then(function (responseData) {
      var restore = responseData.tokens.restore;
      return (0, _myContentApi.restoreAsset)(folderId, assetId, tab, restore).then(function () {
        _this8.modalIsActive = false;
      });
    });
  },
  setInitMyContent: function setInitMyContent(data) {
    var rootFolder = data.rootFolder,
        myUploadsFolder = data.myUploadsFolder,
        tab = data.tab,
        id = data.id,
        selectMultiple = data.selectMultiple;
    this.rootFolder.children = rootFolder.children;
    this.rootFolder.paging = rootFolder.paging;

    if (myUploadsFolder) {
      this.myUploadsFolder.children = myUploadsFolder.children;
      this.myUploadsFolder.paging = myUploadsFolder.paging;
      this.myUploadsFolder.id = myUploadsFolder.id;
    }

    this.rootFolder.title = tab;
    this.rootFolder.id = id;
    this.selectMultiple = selectMultiple;
    this.selectedAssets = [];
  },
  toggleSelectedAsset: function toggleSelectedAsset(asset) {
    var isSelected = this.selectedAssets.find(function (selectedAsset) {
      return selectedAsset.id === asset.id;
    });

    if (!this.selectMultiple) {
      // If we can only select one asset, we're either swapping the existing one
      // for the new one, or removing the existing one
      this.selectedAssets = isSelected ? [] : [asset];
      return;
    } // Otherwise if we can select multiple assets, we're either adding a new one
    // or removing an existing one


    if (!isSelected) {
      this.selectedAssets.push(asset);
    } else {
      // The "correct" way to do this is with Vue.delete, but there has been trouble
      // importing and accessing Vue in the core repo
      this.selectedAssets = this.selectedAssets.filter(function (selectedAsset) {
        return selectedAsset.id !== asset.id;
      });
    }
  },
  selectFolder: function selectFolder(data) {
    this.selectedFolder = data;
  },
  showAddNewFolder: function showAddNewFolder(data) {
    this.isCreatingNewFolder = data;
  },
  showModal: function showModal(data) {
    this.modalIsActive = data;
  },
  setNebulaIcon: function setNebulaIcon(data) {
    this.nebulaIconSvg = data;
  }
});
var _default = myContentModalStore;
exports.default = _default;

/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "444c":
/***/ (function(module, exports) {

module.exports = require("@discoveryedu/nebula-components");

/***/ }),

/***/ "448a":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("2236");

var iterableToArray = __webpack_require__("11b0");

var unsupportedIterableToArray = __webpack_require__("6613");

var nonIterableSpread = __webpack_require__("0676");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4a0c":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.2\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

/***/ }),

/***/ "4a7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ "4ea4":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "5a43":
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "5f02":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "61f2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

var _vue = __webpack_require__("8bbf");

var _hoisted_1 = {
  class: "my-content-modal__heading"
};
var _hoisted_2 = {
  key: 0,
  class: "view my-content",
  index: "0",
  tabindex: "-1"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  key: 1,
  class: "my-content-modal__display-paragraph"
};
var _hoisted_5 = {
  key: 1,
  class: "view my-content",
  index: "0",
  tabindex: "-1"
};
var _hoisted_6 = {
  key: 0,
  class: "my-content-modal__subheading"
};
var _hoisted_7 = {
  class: "my-content-text--bold"
};
var _hoisted_8 = {
  class: "my-content-modal__tabs-container"
};
var _hoisted_9 = {
  key: 1,
  class: "my-content__actions"
};
var _hoisted_10 = {
  class: "my-content__browse"
};
var _hoisted_11 = {
  key: 1,
  class: "my-content__folder"
};
var _hoisted_12 = {
  class: "mode-content"
};
var _hoisted_13 = {
  class: "browse-items",
  role: "list"
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaTabItem = (0, _vue.resolveComponent)("NebulaTabItem");

  var _component_NebulaTabs = (0, _vue.resolveComponent)("NebulaTabs");

  var _component_NebulaButton = (0, _vue.resolveComponent)("NebulaButton");

  var _component_LoadingSpinner = (0, _vue.resolveComponent)("LoadingSpinner");

  var _component_FolderParent = (0, _vue.resolveComponent)("FolderParent");

  var _component_NebulaModal = (0, _vue.resolveComponent)("NebulaModal");

  return (0, _vue.openBlock)(), (0, _vue.createBlock)(_vue.Transition, {
    name: "nebula-modal-transition",
    mode: "out-in"
  }, {
    default: (0, _vue.withCtx)(function () {
      return [$options.modalIsActive && $options.modalDataIsValid ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_NebulaModal, {
        key: 0,
        onCloseModal: $options.closeModal,
        class: "my-content-modal js-comet-modal",
        size: "m"
      }, {
        header: (0, _vue.withCtx)(function () {
          return [(0, _vue.createElementVNode)("h2", _hoisted_1, (0, _vue.toDisplayString)($options.headingCopy), 1)];
        }),
        content: (0, _vue.withCtx)(function () {
          return [$options.enableMoveToTrash ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_2, [!$data.actionPending ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
            key: 0,
            class: "my-content-modal__display-paragraph",
            innerHTML: $options.removeItemText
          }, null, 8, _hoisted_3)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_4, (0, _vue.toDisplayString)(_ctx.$t("Please wait while asset is moved to trash...")), 1))])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_5, [!$options.isChooseModal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_6, [(0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.$t('Select a destination for')) + " ", 1), (0, _vue.createElementVNode)("span", _hoisted_7, (0, _vue.toDisplayString)($options.subHeadingCopy), 1)])) : (0, _vue.createCommentVNode)("", true), (0, _vue.createElementVNode)("div", _hoisted_8, [(0, _vue.createVNode)(_component_NebulaTabs, {
            "aria-label": "My content tab navigation"
          }, {
            tabs: (0, _vue.withCtx)(function () {
              return [((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, null, (0, _vue.renderList)($options.filteredTabs, function (tab, index) {
                return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_NebulaTabItem, {
                  key: index,
                  name: tab.label,
                  selected: $options.isSelected(tab.type),
                  onClick: function onClick($event) {
                    return $options.setSelectedTab(tab.type);
                  },
                  ref_for: true,
                  ref: "tabButtons"
                }, null, 8, ["name", "selected", "onClick"]);
              }), 128))];
            }),
            _: 1
          })]), !$options.isChooseModal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [(0, _vue.createVNode)(_component_NebulaButton, {
            onClick: $options.addNewFolder,
            isDisabled: $options.loadingFolders,
            "icon-left": "folder-add",
            text: _ctx.$t('Add New Folder')
          }, null, 8, ["onClick", "isDisabled", "text"])])) : (0, _vue.createCommentVNode)("", true), (0, _vue.createElementVNode)("div", _hoisted_10, [$options.loadingFolders ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_LoadingSpinner, {
            key: 0,
            isLoading: $options.loadingFolders
          }, null, 8, ["isLoading"])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [(0, _vue.createElementVNode)("div", _hoisted_12, [(0, _vue.createElementVNode)("div", _hoisted_13, [(0, _vue.createVNode)(_component_FolderParent, {
            isFromMyContent: $options.isFromMyContent,
            isChooseModal: $options.isChooseModal,
            options: {
              myContent: $setup.myContentModalStore.rootFolder
            },
            assetId: $props.asset ? $props.asset.selectedAssetId : null,
            selectedTab: $data.selectedTab,
            isImagesOnly: $options.isImagesOnly
          }, null, 8, ["isFromMyContent", "isChooseModal", "options", "assetId", "selectedTab", "isImagesOnly"]), $options.isChooseModal && $data.selectedTab.type === 'user' ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_FolderParent, {
            key: 0,
            isFromMyContent: $options.isFromMyContent,
            isChooseModal: "",
            options: {
              myContent: $setup.myContentModalStore.myUploadsFolder
            },
            assetId: $props.asset ? $props.asset.selectedAssetId : null,
            selectedTab: $data.selectedTab,
            isImagesOnly: $options.isImagesOnly
          }, null, 8, ["isFromMyContent", "options", "assetId", "selectedTab", "isImagesOnly"])) : (0, _vue.createCommentVNode)("", true)])])]))])]))];
        }),
        actionsRow: (0, _vue.withCtx)(function () {
          return [(0, _vue.createVNode)(_component_NebulaButton, {
            ref: "closeButton",
            onClick: $options.closeModal,
            type: "ghost",
            isDisabled: !!$data.actionPending,
            text: _ctx.$t('Close')
          }, null, 8, ["onClick", "isDisabled", "text"]), $options.useAddAction ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_NebulaButton, {
            key: 0,
            onClick: $options.handleAddAssetToFolder,
            isDisabled: !!$data.actionPending || $options.loadingFolders || $options.isChooseModal && !$options.selectedAssets.length,
            text: _ctx.$t('Add')
          }, null, 8, ["onClick", "isDisabled", "text"])) : (0, _vue.createCommentVNode)("", true), ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, null, (0, _vue.renderList)($options.availableActions, function (action) {
            return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_NebulaButton, {
              key: action.type,
              onClick: function onClick($event) {
                return $options.handleClick(action.method);
              },
              isDisabled: !!$data.actionPending || $options.loadingFolders || $options.isChooseModal && !$options.selectedAssets.length,
              text: $options.getActionLabel(action)
            }, null, 8, ["onClick", "isDisabled", "text"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["onCloseModal"])) : (0, _vue.createCommentVNode)("", true)];
    }, undefined, true),
    _: 1
  });
}

/***/ }),

/***/ "6613":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("5a43");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "6b0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.default = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ "6cc2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  name: 'LoadingSpinner',
  props: {
    isLoading: {
      type: Boolean
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "7037":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "76ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e8ef");
/* harmony import */ var _MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3f83");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _MyContentModal_vue_vue_type_style_index_0_id_40b95082_lang_stylus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2349");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6b0d");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3__);







const __exports__ = /*#__PURE__*/_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3___default()(_MyContentModal_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__["default"], [['render',_MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0__["render"]]])

/* harmony default export */ __webpack_exports__["default"] = (__exports__);

/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "7d7c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("4ea4");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__("a34a"));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__("c973"));

var _NebulaIcon = _interopRequireDefault(__webpack_require__("007c"));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__("d76c"));

var _store = _interopRequireDefault(__webpack_require__("4360"));

var _default = {
  name: 'FolderParent',
  components: {
    NebulaIcon: _NebulaIcon.default,
    LoadingSpinner: _LoadingSpinner.default
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    isChooseModal: Boolean,
    isImagesOnly: {
      type: Boolean
    },
    isFromMyContent: {
      type: Boolean,
      default: false
    },
    assetId: {
      type: String
    },
    selectedTab: {
      type: Object
    }
  },
  data: function data() {
    return {
      folderOpened: false,
      folderTitle: '',
      folderIsLoading: false,
      loadMoreObserver: null
    };
  },
  computed: {
    mycontent: function mycontent() {
      var myContent = this.options.myContent;
      return myContent;
    },
    nextPage: function nextPage() {
      if (this.mycontent.paging && this.mycontent.paging.page < this.mycontent.paging.total_pages) {
        return this.mycontent.paging.page + 1;
      }

      return null;
    },
    filteredContent: function filteredContent() {
      var _this = this;

      // we don't want the ability to move/copy a folder into itself
      return this.isFromMyContent ? this.mycontent.children && this.mycontent.children.filter(function (child) {
        return child.id !== _this.assetId;
      }) : this.mycontent.children;
    },
    filteredImages: function filteredImages() {
      var items = this.filteredContent;
      var itemTypes = ['3123b3ad-3c2d-49cf-92ce-9927c3c09e64', // image
      '1aa883f4-b310-4a5a-9d35-d07dc8cadf6c', // non-searchable-image
      '89cb88bc-1b04-4de2-8986-e82f65df2755' // folder
      ];
      return items.filter(function (item) {
        return itemTypes.includes(item.type.id);
      });
    },
    caretStatus: function caretStatus() {
      return this.folderOpened ? 'rotate--down' : 'rotate--right';
    },
    isFolder: function isFolder() {
      // Folders always have a children array, even if it is empty
      return !!this.mycontent.children;
    },
    selected: function selected() {
      var _this2 = this;

      return !this.isChooseModal && this.mycontent.id === this.myContentModalStore.selectedFolder || this.myContentModalStore.selectedAssets.find(function (selectedAsset) {
        return selectedAsset.id === _this2.mycontent.id;
      });
    },
    showAddNewFolderActive: function showAddNewFolderActive() {
      return this.selected && this.myContentModalStore.isCreatingNewFolder;
    },
    toggleFolderButtonLabel: function toggleFolderButtonLabel() {
      return this.folderOpened ? this.$t('close folder') : this.$t('open folder to reveal child folders');
    },
    titleFolderButtonLabel: function titleFolderButtonLabel() {
      return this.folderOpened || this.folderOpened && this.selected ? this.$t('folder selected') : this.$t('select folder to save content to it');
    },
    isDisabled: function isDisabled() {
      return this.folderTitle.length <= 1;
    }
  },
  setup: function setup() {
    return {
      myContentModalStore: _store.default
    };
  },
  methods: {
    attachLoadMoreObserver: function attachLoadMoreObserver() {
      var _this3 = this;

      // Watch for the "load more" banner to appear, and then load more items
      this.loadMoreObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this3.loadMoreItems();

            _this3.loadMoreObserver.unobserve(entry.target);

            _this3.loadMoreObserver = null;
          }
        });
      }, {
        root: document.querySelector('.my-content__browse')
      });
      this.loadMoreObserver.observe(this.$refs.loadMoreBanner);
    },
    handleFolderToggleClick: function handleFolderToggleClick() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.folderOpened) {
                  _context.next = 10;
                  break;
                }

                // Open the folder and fetch its contents
                _this4.folderIsLoading = true;
                _this4.folderOpened = true;

                _this4.myContentModalStore.selectFolder(_this4.mycontent.id);

                if (_this4.mycontent.children.length) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this4.myContentModalStore.fetchNestedFolder({
                  id: _this4.mycontent.id,
                  isChooseModal: _this4.isChooseModal,
                  tab: _this4.selectedTab.type
                });

              case 7:
                _this4.folderIsLoading = false;
                _context.next = 11;
                break;

              case 10:
                _this4.folderOpened = false;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleFolderTitleClick: function handleFolderTitleClick() {
      // if the folder is opened, make sure its the selected folder
      // otherwise open the folder and fetch its content
      if (!this.folderOpened) {
        this.handleFolderToggleClick();
      } else {
        this.myContentModalStore.selectFolder(this.mycontent.id);
      }
    },
    loadMoreItems: function loadMoreItems() {
      this.myContentModalStore.fetchNestedFolder({
        id: this.mycontent.id,
        isChooseModal: this.isChooseModal,
        page: this.nextPage,
        tab: this.selectedTab.type
      });
    },
    removeAddNewFolderForm: function removeAddNewFolderForm() {
      this.myContentModalStore.showAddNewFolder(false);
    },
    createNewFolder: function createNewFolder() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var payload;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                payload = {
                  folderParentId: _this5.myContentModalStore.selectedFolder || _this5.myContentModalStore.rootFolderIds[_this5.selectedTab.type],
                  title: _this5.folderTitle,
                  tab: _this5.selectedTab.type
                };
                _this5.folderIsLoading = true;
                _context2.next = 4;
                return _this5.myContentModalStore.addNewContentFolder(payload);

              case 4:
                _this5.folderIsLoading = false;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    toggleAsset: function toggleAsset() {
      // If we've selected an asset, save that asset to use later; otherwise remove it from our list
      this.myContentModalStore.toggleSelectedAsset({
        id: this.mycontent.id,
        is_user_created: this.mycontent.is_user_created,
        title: this.mycontent.title,
        type: this.mycontent.type
      });
    }
  },
  mounted: function mounted() {
    // Root folders (other than My Uploads) should begin opened
    if (this.mycontent.root && this.mycontent.title !== 'My Uploads') {
      this.folderOpened = true;
    }

    if (this.nextPage) {
      this.attachLoadMoreObserver();
    }
  },
  beforeUnmount: function beforeUnmount() {
    if (this.loadMoreObserver) {
      this.loadMoreObserver.unobserve(this.$refs.loadMoreBanner);
    }
  },
  watch: {
    nextPage: function nextPage(_nextPage) {
      var _this6 = this;

      if (_nextPage && !this.loadMoreObserver) {
        this.$nextTick(function () {
          _this6.attachLoadMoreObserver();
        });
      }
    },
    showAddNewFolderActive: function showAddNewFolderActive(isActive) {
      var _this7 = this;

      if (isActive) {
        this.$nextTick(function () {
          _this7.$refs.addNewFolderInput.focus();
        });
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "7ec2":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("7037")["default"];

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "83b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "848b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__("4a0c");

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "9523":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "9aad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("20e0");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0__, "render")) __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_template_id_e1f2443a__WEBPACK_IMPORTED_MODULE_0__["render"]; });



/***/ }),

/***/ "a34a":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("7037");

// TODO(Babel 8): Remove this file.
var runtime = __webpack_require__("7ec2")();

module.exports = runtime; // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/***/ }),

/***/ "a44a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3b38");
/* harmony import */ var _FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c94d");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _FolderParent_vue_vue_type_style_index_0_id_258f8945_lang_stylus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f00c");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6b0d");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3__);







const __exports__ = /*#__PURE__*/_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3___default()(_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__["default"], [['render',_FolderParent_vue_vue_type_template_id_258f8945__WEBPACK_IMPORTED_MODULE_0__["render"]]])

/* harmony default export */ __webpack_exports__["default"] = (__exports__);

/***/ }),

/***/ "acec":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}html{color:#595959;font-family:Proxima Vara,Arial,sans-serif;font-weight:400;line-height:1.4;font-size:1.125rem;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:16px}.nebula-screenreader-only{clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}.my-content-modal.modal-container{z-index:100}.my-content-modal .my-content__tab-link,.my-content-modal .my-content__tab-link:active,.my-content-modal .my-content__tab-link:focus,.my-content-modal .my-content__tab-link:hover,.my-content-modal .my-content__tab-link:visited{background:none;border:none;color:#2b303b;font-family:Proxima Nova,Arial,sans-serif}.my-content-modal .comet-tab__label:last-child{margin-left:16px}.my-content-modal .my-content .my-content-text--bold{font-weight:700}.my-content-modal .my-content__tabs{margin-bottom:0}.my-content-modal .my-content__actions{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:8px 0 16px}.my-content-modal .my-content__actions .comet-button{font-size:1rem;margin:0}.my-content-modal .my-content__browse{max-height:250px;overflow-y:auto}@media screen and (min-width:600px){.my-content-modal .my-content__browse{max-height:none}}.my-content-modal .my-content__folder{max-height:auto;min-height:auto;overflow-y:auto}@media screen and (min-width:600px){.my-content-modal .my-content__folder{max-height:246px;min-height:246px}}@media screen and (min-width:1024px){.my-content-modal .my-content__folder{max-height:320px;min-height:320px}}.my-content-modal .my-content__folder .folder{border-bottom:1px solid #c4c9d4;margin:0 0 0 24px;padding:0}.my-content-modal .my-content__folder .folder.folder-parent{margin-left:0}.my-content-modal .my-content__folder .folder .folder:last-child{border-bottom:none}.my-content-modal .my-content__folder .folder--loading-indicator .folder__selectable{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#576075;gap:8px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.my-content-modal .my-content__folder .folder--loading-indicator .my-content-modal__spinner{min-height:0}.my-content-modal .my-content__folder .folder--loading-indicator .my-content-modal__spinner svg{height:18px;width:18px}.my-content-modal .my-content__folder .folder+.folder__browse,.my-content-modal .my-content__folder .folder+.folder__create{display:none}.my-content-modal .my-content__folder .folder.opened+.folder__browse,.my-content-modal .my-content__folder .folder.opened+.folder__create{display:block}.my-content-modal .my-content__folder .folder__item,.my-content-modal .my-content__folder .folder__item:focus,.my-content-modal .my-content__folder .folder__item:hover{color:#2d6a9f;font-family:Proxima Nova,Arial,sans-serif;font-size:1rem;text-decoration:none}.my-content-modal .my-content__folder .folder__selectable{border:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;padding:12px 0;position:relative}.my-content-modal .my-content__folder .folder__selectable--selected:not(.folder__item--asset){background:#f0f2f4}.my-content-modal .my-content__folder .folder__icon-btn{background-color:transparent;border:none;cursor:pointer;height:20px;margin-left:8px;padding:0;width:20px}.my-content-modal .my-content__folder .folder__item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.my-content-modal .my-content__folder .folder__item--asset{color:#2b303b;padding-left:26px}.my-content-modal .my-content__folder .folder__checkbox{cursor:pointer;opacity:0;position:absolute}.my-content-modal .my-content__folder .folder__checkbox:focus+.folder__item{outline:1px solid #0b0c0f}.my-content-modal .my-content__folder .folder__create{margin:0;padding:12px 0}.my-content-modal .my-content__folder .folder__form{display:-webkit-box;display:-ms-flexbox;display:flex}.my-content-modal .my-content__folder .folder__form .folder__input{font-size:1rem;height:36px;margin:0 12px 0 0;padding:8px;width:160px}.my-content-modal .my-content__folder .folder__form .comet-button{height:36px;margin:0;margin-inline:10px;padding:0 8px}.my-content-modal .my-content__folder .folder__form .comet-button:last-child{margin:0}.my-content-modal .my-content__folder .folder__form .comet-button__icon{margin:-3px 0 0 0}.my-content-modal .my-content__folder .folder__selectable{-ms-flex-line-pack:center;align-content:center;cursor:default;padding-bottom:0;padding-right:0;padding-top:0;height:40px;width:100%}.my-content-modal .my-content__folder .folder__icon-btn{height:100%;width:40px}.my-content-modal .my-content__folder .folder__item{height:100%}.my-content-modal .my-content__folder .browse-items{border-top:0;list-style-type:none;margin-bottom:0;margin-left:0;margin-top:0;overflow:hidden;padding:0}.my-content-modal .my-content__folder .browse-items .folder-parent button svg{-webkit-transition:.1s ease-out;transition:.1s ease-out}.my-content-modal .my-content__folder .browse-items .rotate--right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.my-content-modal .my-content__folder .browse-items .rotate--down{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.my-content-modal .my-content__folder .browse-items ul{list-style-type:none;margin-left:0}.my-content-modal .my-content__folder .browse-items div .folder{margin:0;padding-left:0}.my-content-modal .my-content__folder .browse-items div .browse-items div .folder .folder__selectable{padding-left:24px}.my-content-modal .my-content__folder .browse-items div .browse-items div .browse-items div .folder .folder__selectable{padding-left:48px}.my-content-modal .my-content__folder .browse-items div .browse-items div .browse-items div .browse-items div .folder .folder__selectable{padding-left:72px}.my-content-modal .my-content__folder .browse-items div .browse-items div .browse-items div .browse-items div .browse-items div .folder .folder__selectable{padding-left:96px}.my-content-modal .my-content__folder .browse-items div .browse-items div .browse-items div .browse-items div .browse-items div .browse-items div .folder .folder__selectable{padding-left:120px}.my-content-modal .my-content__folder .browse-items div .browse-items div .browse-items div .browse-items div .browse-items div .browse-items div .browse-items div .folder .folder__selectable{padding-left:144px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var cookies = __webpack_require__("7aac");
var buildURL = __webpack_require__("30b5");
var buildFullPath = __webpack_require__("83b9");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var defaults = __webpack_require__("2444");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "c94d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7d7c");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 

/***/ }),

/***/ "c973":
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var mergeConfig = __webpack_require__("4a7b");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("5f02");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "d74a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dac8");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("149b1886", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d76c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1ad9");
/* harmony import */ var _LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3d2a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _LoadingSpinner_vue_vue_type_style_index_0_id_1af271bc_lang_stylus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d880");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6b0d");
/* harmony import */ var _home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3__);







const __exports__ = /*#__PURE__*/_home_runner_work_my_content_modal_my_content_modal_node_modules_vue_loader_v16_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_3___default()(_LoadingSpinner_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__["default"], [['render',_LoadingSpinner_vue_vue_type_template_id_1af271bc__WEBPACK_IMPORTED_MODULE_0__["render"]]])

/* harmony default export */ __webpack_exports__["default"] = (__exports__);

/***/ }),

/***/ "d880":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_style_index_0_id_1af271bc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f4f9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_style_index_0_id_1af271bc_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_LoadingSpinner_vue_vue_type_style_index_0_id_1af271bc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dac8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}html{color:#595959;font-family:Proxima Vara,Arial,sans-serif;font-weight:400;line-height:1.4;font-size:1.125rem;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:16px}.nebula-screenreader-only{clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}.my-content__browse .my-content-modal__spinner{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:250px}.my-content-modal__heading{font-size:1.75rem}.my-content-modal__display-paragraph{margin:16px 0 24px}.my-content-modal__display-paragraph .my-content--bold-text{font-weight:700}.my-content-modal__subheading{margin-block:16px}.my-content-modal__tabs-container{-webkit-margin-before:16px;margin-block-start:16px}.my-content-modal__tabs-container .nebula-tabs__list-item .nebula-button--flat:focus,.my-content-modal__tabs-container .nebula-tabs__list-item .nebula-button--flat:hover{background-color:transparent}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e8ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("61f2");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0__, "render")) __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_cache_loader_dist_cjs_js_ref_13_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_v16_dist_templateLoader_js_ref_6_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MyContentModal_vue_vue_type_template_id_40b95082__WEBPACK_IMPORTED_MODULE_0__["render"]; });



/***/ }),

/***/ "f00c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_style_index_0_id_258f8945_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2ebf");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_style_index_0_id_258f8945_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_FolderParent_vue_vue_type_style_index_0_id_258f8945_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f4f9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("102f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("56e4b122", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setPublicPath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1eb2");
/* harmony import */ var _entry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("76ec");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _entry__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _entry__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));


/* harmony default export */ __webpack_exports__["default"] = (_entry__WEBPACK_IMPORTED_MODULE_1__["default"]);



/***/ })

/******/ })["default"];
//# sourceMappingURL=MyContentModal.common.js.map